import { Injectable } from '@angular/core';

import { environment } from '@cpcac/common/environments/environment';

/**
 * App config service.
 * Provides information about current application environment configuration.
 */
@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  /**
   * API base URL.
   */
  public readonly apiUrl = environment.apiUrl;
}
